<template>
    <div>
        <card-header title="Tasks" icon="fa-tasks"/>
        <card-body>
            <card-list>
                <!-- Anyone's overdue work, front and centre -- only when there is some. -->
                <template v-if="tasks.totals.overdue > 0">
                    <task-navigation-list-item
                        title="Overdue"
                        icon="fa-exclamation-triangle"
                        danger
                        :tasks="tasks.totals.overdue"
                        :active="child && child.definition.component === 'task-details' && child.props.type === 'overdue'"
                        @click="$openCard('task-details', {type: 'overdue'}, card)"
                    />
                    <separator-list-item/>
                </template>

                <subheader-list-item title="Your Trip Tasks" icon="fa-tennis-ball" :badge="tasks.assigned.trips"/>

                <task-navigation-list-item
                    title="Trips"
                    icon="fa-tennis-ball"
                    :tasks="tasks.assigned.trip"
                    :active="child && child.definition.component === 'task-details' && child.props.type === 'trip'"
                    @click="$openCard('task-details', {type: 'trip'}, card)"
                />
                <task-navigation-list-item
                    title="Events"
                    icon="fa-users"
                    :tasks="tasks.assigned.trip_events"
                    :active="child && child.definition.component === 'task-details' && child.props.type === 'trip-events'"
                    @click="$openCard('task-details', {type: 'trip-events'}, card)"
                />
                <task-navigation-list-item
                    title="Add-Ons"
                    icon="fa-layer-plus"
                    :tasks="tasks.assigned.trip_addons"
                    :active="child && child.definition.component === 'task-details' && child.props.type === 'trip-addons'"
                    @click="$openCard('task-details', {type: 'trip-addons'}, card)"
                />
                <task-navigation-list-item
                    title="Hotels"
                    icon="fa-hotel"
                    :tasks="tasks.assigned.trip_hotels"
                    :active="child && child.definition.component === 'task-details' && child.props.type === 'trip-hotels'"
                    @click="$openCard('task-details', {type: 'trip-hotels'}, card)"
                />

                <subheader-list-item title="Your Registration Tasks" icon="fa-suitcase-rolling" :badge="tasks.assigned.registrations"/>

                <task-navigation-list-item
                        title="Registrations"
                        icon="fa-suitcase"
                        :tasks="tasks.assigned.registration"
                        :active="child && child.definition.component === 'task-details' && child.props.type === 'registration'"
                        @click="$openCard('task-details', {type: 'registration'}, card)"
                />

                <task-navigation-list-item
                        title="Flights"
                        icon="fa-plane"
                        :tasks="tasks.assigned.flights"
                        :active="child && child.definition.component === 'task-details' && child.props.type === 'flights'"
                        @click="$openCard('task-details', {type: 'flights'}, card)"
                />

                <task-navigation-list-item
                        title="Hotels"
                        icon="fa-hotel"
                        :tasks="tasks.assigned.reg_hotels"
                        :active="child && child.definition.component === 'task-details' && child.props.type === 'reg-hotels'"
                        @click="$openCard('task-details', {type: 'reg-hotels'}, card)"
                />

                <task-navigation-list-item
                        title="Events"
                        icon="fa-users"
                        :tasks="tasks.assigned.reg_events"
                        :active="child && child.definition.component === 'task-details' && child.props.type === 'reg-events'"
                        @click="$openCard('task-details', {type: 'reg-events'}, card)"
                />

                <task-navigation-list-item
                    title="Add-Ons"
                    icon="fa-layer-plus"
                    :tasks="tasks.assigned.reg_addons"
                    :active="child && child.definition.component === 'task-details' && child.props.type === 'reg-addons'"
                    @click="$openCard('task-details', {type: 'reg-addons'}, card)"
                />

                <!-- Non-trip-scoped work: customers, leads and contacts. -->
                <subheader-list-item title="Your Other Tasks" icon="fa-clipboard-check" :badge="tasks.assigned.other"/>

                <task-navigation-list-item
                        title="Customers"
                        icon="fa-user"
                        :tasks="tasks.assigned.customer"
                        :active="child && child.definition.component === 'task-details' && child.props.type === 'customer'"
                        @click="$openCard('task-details', {type: 'customer'}, card)"
                />

                <task-navigation-list-item
                        title="Leads"
                        icon="fa-address-card"
                        :tasks="tasks.assigned.lead"
                        :active="child && child.definition.component === 'task-details' && child.props.type === 'lead'"
                        @click="$openCard('task-details', {type: 'lead'}, card)"
                />

                <task-navigation-list-item
                        title="Contacts"
                        icon="fa-address-book"
                        :tasks="tasks.assigned.contact"
                        :active="child && child.definition.component === 'task-details' && child.props.type === 'contact'"
                        @click="$openCard('task-details', {type: 'contact'}, card)"
                />

                <separator-list-item/>

                <!-- Team queues: one row per assignable staff member plus the
                     unassigned pool. Open to everyone -- the same work is
                     already visible to all staff via the Trips drill-down. -->
                <subheader-list-item title="Assigned Tasks" icon="fa-users"/>

                <task-navigation-list-item
                    v-for="queue in teamQueues"
                    :key="queue.id === null ? 'unassigned' : queue.id"
                    :title="queue.name"
                    :icon="queue.id === null ? 'fa-inbox' : 'fa-user'"
                    :tasks="queue.total"
                    :active="child && child.definition.component === 'user-tasks' && child.props.assigneeId === assigneeKey(queue)"
                    @click="$openCard('user-tasks', {assigneeId: assigneeKey(queue)}, card)"
                />

            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardList from "../../TIER/components/CardList";
    import CardBody from "../../TIER/components/CardBody";
    import NavigationListItem from "../../TIER/components/NavigationListItem";
    import {client as http} from "../../http_client";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import {mapActions, mapGetters} from 'vuex';
    import CardFooter from "../../TIER/components/CardFooter";
    import SeparatorListItem from "../../TIER/components/SeparatorListItem";
    import TaskNavigationListItem from "@/components/TaskNavigationListItem";

    export default {
        props: ['card', 'child'],
        components: {TaskNavigationListItem, SeparatorListItem, SubheaderListItem, NavigationListItem, CardBody, CardList, CardHeader},
        data: function () {
            return {
            };
        },
        computed: {
            ...mapGetters(['tasks', 'currentUser']),
            // Everyone's queues except your own -- yours is already the top
            // half of this card.
            teamQueues() {
                return (this.tasks.byAssignee || []).filter(q => q.id !== this.currentUser.id);
            }
        },
        methods: {
            ...mapActions(['updateTasks']),
            // Card props round-trip as strings; the unassigned pool has no id.
            assigneeKey(queue) {
                return queue.id === null ? 'unassigned' : String(queue.id);
            },
            loadTasks() {
                this.$emit('loading', true);
                this.updateTasks().then(() => {
                    this.$emit('loading', false);
                });
            },
            reload() {
                this.loadTasks();
            }
        },
        mounted() {
            this.loadTasks();
        }
    };
</script>

<style lang="scss" scoped>

</style>
